export default {
  wrapper: {
    base: {
      variant: 'spark.base.wrapper'
    },
    variants: {}
  },
  tabIcon: {
    base: {
      display: 'inline-block',
      height: '24px',
      width: '24px',
      lineHeight: '24px',
      overflow: 'hidden',
      mr: 'xxs',
      textAlign: 'center'
    }
  },
  tabListContainer: {
    base: {
      overflowX: 'scroll',
      MsOverflowStyle: 'none',
      '::-webkit-scrollbar': {
        display: 'none'
      },
      scrollbarWidth: 'none'
    }
  },
  tabListContent: {
    base: {
      minWidth: '100%',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      borderBottomWidth: '1px',
      borderBottomColor: 'grey-30',
      borderBottomStyle: 'solid'
    }
  },
  tabPanels: {
    base: {}
  },
  tab: {
    base: {
      display: 'inline-flex',
      alignItems: 'center',
      p: 0,
      m: '0',
      ml: ['md', 'md', '40px'],
      ':first-of-type': {
        ml: '0'
      },
      border: 'none',
      borderRadius: 0,
      backgroundColor: 'transparent',
      appearance: 'none',
      fontFamily: 'base',
      fontWeight: '600',
      fontSize: ['xxs', 'xxs', 'base'],
      lineHeight: ['16px', '16px', 'base'],
      userSelect: 'none',
      cursor: 'pointer',
      color: 'grey-50',
      hover: {
        color: 'grey-100'
      },
      focus: {
        color: 'grey-100',
        backgroundColor: 'secondary',
        outline: 'none'
      }
    },
    variants: {
      active: {
        variant: 'spark.element.tabs.tab.base',
        borderBottomWidth: '3px',
        borderBottomColor: 'grey-100',
        borderBottomStyle: 'solid',
        paddingBottom: '8px',
        color: 'grey-100',
        outline: 'none',
        pointerEvents: 'none'
      }
    }
  }
};